  <div class="row animate fadeIn">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <input #input (keyup)="buscarInmuebles(input.value)" type="text" class="form-control"
            placeholder="Buscar inmuebles...">
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="alert alert-info" *ngIf="inmuebles.length === 0" >
      No hay resultados de la búsqueda
  </div>

    <div class="col-md-12 col-sm-12 col-lg-12" *ngFor="let inmueble of inmuebles">
        <div class="card">
          <h1 class="card-title mt-4" align="center" style="color: #007bff;">{{inmueble.nombre}}</h1>
          <div class="p-carousel" >
            <div class="carousel slide" align="center" data-ride="carousel" id="{{inmueble._id}}">
                <div class="carousel-inner" role="listbox">
                  <div *ngFor="let avatar of inmueble.imagen; let i = index" class="carousel-item" [ngClass]="{'active': i===0}">
                    <img style="width:70%; height:310px" [src]='avatar.url' class="img-responsive image">
                  </div>
                </div>

                <img *ngIf="inmueble.imagen.length===0" style="width:70%; height:310px" src="assets/images/notinmueble.png" class="img-responsive image">

                <div>
                  <a class="carousel-control-prev" style="background-color: rgb(72, 126, 157);" href="#{{inmueble._id}}" role="button"
                  data-slide="prev"><span class="carousel-control-prev-icon"></span>
                  <span class="sr-only">Previous</span></a><a  style="background-color: rgb(72, 126, 157);" class="carousel-control-next"
                  href="#{{inmueble._id}}" role="button" data-slide="next"><span
                  class="carousel-control-next-icon"></span><span class="sr-only">Next</span></a>
                </div>

            </div>
        </div>

            <div class="card-body">

                <p style="text-align: right; font-size: 28px; color: rgb(238, 70, 70); font-weight: bold;"><b>${{inmueble.precioalquiler}}</b></p>

                <div class="row">
                  <div class="col-md-6">
                    <div style="color: #000;"><b>Código del inmueble:</b></div>
                  <div>{{inmueble.codigo}}</div>
                  </div>

                  <div class="col-md-6">
                    <div style="color: #000;"><b>Servicios incluidos:</b></div>
                  <div>{{inmueble.servicio}}</div>
                  </div>
                </div>
                <br>
                  <div style="color: #000;"><b>Dirección:</b></div>
                  <p><i class="fa fa-map-marker marker"></i> {{inmueble.direccion}}</p>
            </div>
            <button [routerLink]="['/alquilar', inmueble._id]" style="height: 40px; font-size: 20px; background: #17a2b8; border: 0px;" class="btn btn-block btn-primary"><abbr title="Alquilar inmueble"></abbr>ALQUILAR</button>
        </div>

    </div>
  </div>
  <div class="row" align="center">
    <div class="col">
      <button (click)="cambiarPaginacion(-6)" class="btn btn-circle btn-lg btn-success mr-2"><</button>
      <button (click)="cambiarPaginacion(6)" class="btn btn-circle btn-lg btn-success">></button>
    </div>
  </div>




